import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[70vh] items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-500"><XCircle size={28} /></span>
        <h1 className="mt-4 font-head text-xl font-extrabold text-slate-900">Checkout cancelled</h1>
        <p className="mt-1 text-[13px] text-slate-500">No charge was made. You can pick a plan whenever you're ready.</p>
        <button onClick={() => navigate("/billing")} data-testid="cancel-back" className="mt-5 rounded-xl bg-[#1a5fd0] px-5 py-2.5 font-head text-[14px] font-bold text-white hover:bg-[#1550b8]">Back to plans</button>
      </div>
    </div>
  );
}
